import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { SearchToneDto } from '../../../dto/searchtone/searchtonedto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface SearchToneResponse extends MiddlewareAPIResponse
{
    getListOfSearchToneDtos(): SearchToneDto;
}

export class SearchToneResponseDtoImpl extends MiddlewareDtoImpl implements SearchToneResponse
{
    private searchToneDetailsRespnseDtos : SearchToneDto;

    getListOfSearchToneDtos(): SearchToneDto
    {
        return this.searchToneDetailsRespnseDtos;
    }
    setSearchToneDto(searchToneDetailsRespnseDtos: SearchToneDto)
    {
        this.searchToneDetailsRespnseDtos = searchToneDetailsRespnseDtos;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/search/searchtone/searchtoneresponse.tsx